export default function Logo({ variant = "horizontal", className = "" }) {
    const src = variant === "stacked" ? "/japet-logo.png" : "/japet-logo-2.png";
    const sizeClass = variant === "stacked" ? "h-40 md:h-48" : "h-28 md:h-32";
    return (
        <img
            src={src}
            alt="Japet Agencement — l'art de rénover"
            className={`${sizeClass} w-auto object-contain ${className}`}
            data-testid="brand-logo"
        />
    );
}
